import { Button, Modal } from "@/components";
import styles from "./DeleteDeviceModal.module.scss";

type DeleteDeviceModalProps = {
  isOpen: boolean;
  deviceName: string;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
};

export const DeleteDeviceModal = ({
  isOpen,
  deviceName,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteDeviceModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={isDeleting ? () => {} : onClose}>
      <div className={styles["comp"]}>
        <div>
          <div className={styles["comp__heading"]}>Delete device?</div>
          <p className={styles["comp__description"]}>
            This removes the device record and its enrollment data from the organization. This cannot be undone.
          </p>
          <div className={styles["comp__fileName"]} title={deviceName}>
            „{deviceName}”
          </div>
        </div>

        <div className={styles["comp__actions"]}>
          <Button type="button" variant="secondary" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? "Deleting…" : "Delete"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
